<template>
  <md-card
    class="md-card-tabs"
    :class="[
      { 'flex-column': flexColumn },
      { 'nav-pills-icons': navPillsIcons },
      { 'md-card-plain': plain }
    ]"
  >
    <div class="tab_header" v-if="title">
      <div class="tab-title">
        <div class="tab-icon" v-if="icon">
          <md-icon>{{ icon }}</md-icon>
        </div>
        {{ title }}
      </div>
    </div>
    <md-card-content>
      <md-list class="nav-tabs">
        <md-list-item
          v-for="(item, index) in tabName"
          @click="switchPanel(tabName[index])"
          :key="item"
          :class="[
            { active: isActivePanel(tabName[index]) },
            { [getColorButton(colorButton)]: isActivePanel(tabName[index]) },
            { disabled: disabled}
          ]"
        >
          {{ tabName[index] }}
          <md-icon v-if="navPillsIcons">{{ tabIcon[index] }}</md-icon>
        </md-list-item>
        <div class="action-button">
          <md-button
            v-if="actionButtonText"
            class="md-primary md-sm"
            @click="$emit('clickActionButton')"
            :disabled="isLoading"
          >
            {{ actionButtonText }}
          </md-button>
        </div>
        <div class="action-button">
          <md-button
            v-if="secondActionButtonText"
            class="md-primary md-sm"
            @click="$emit('secondClickActionButton')"
            :disabled="isLoading"
          >
            {{ secondActionButtonText }}
          </md-button>
        </div>
      </md-list>

      <transition name="fade" mode="out-in">
        <div class="tab-content">
          <template v-for="(item, index) in tabName">
            <template v-if="isActivePanel(tabName[index])">
              <div :class="getTabContent(index + 1)" :key="item">
                <slot :name="getTabContent(index + 1)">
                  This is the default text!
                </slot>
              </div>
            </template>
          </template>
        </div>
      </transition>
    </md-card-content>
  </md-card>
</template>

<script>
export default {
  props: {
    flexColumn: Boolean,
    navPillsIcons: Boolean,
    plain: Boolean,
    tabName: Array,
    tabIcon: Array,
    colorButton: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    title:{
      type: String,
      required: false,
    },
    isLoading:{
      type: Boolean,
      required: false,
    },
    icon:{
      type: String,
      required: false,
    },
    disabledTabs: {
      type: Array,
      required: false,
      default: () => { return [] },
    },
    actionButtonText: {
      type: String,
      default: null
    },
    secondActionButtonText: {
      type: String,
      default: null
    },
  },
  methods: {
    switchPanel(panel) {
      // tabs not disabled and panel not in disabledTabs
      if (!this.disabled && this.disabledTabs.indexOf(panel) === -1) {
        this.$emit('input', panel);
      }

      // show popup read privacy consent
      if (panel === 'Verbal' && this.disabledTabs.indexOf(panel) === -1) {
        this.$emit('show-script');
      }
    },
    isActivePanel(panel) {
      return this.value == panel;
    },
    getColorButton: function(colorButton) {
      return "md-" + colorButton + "";
    },
    getTabContent: function(index) {
      return "tab-pane-" + index + "";
    }
  },
  created(){
    if(this.value == null)
      this.value = this.tabName[0];
  }
}
</script>

<style scoped lang="scss">
.tab_header {
  background: #EEEEEE;
  padding: 5px 5px 5px 15px;
  .tab-icon {
    float: left;
    margin-right: 5px;
  }
  .tab-title{
    font-size: 18px;
    color: rgba(0, 0, 0, 0.54);
    font-weight: 500;
  }
}

.action-button {
  margin-left:30px;
}
</style>
